import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import SurveyLayout from "@pulse/features/SurveyResponse/SurveyLayout";
import { SurveySteps } from "@pulse/features/SurveyResponse/SurveyResponse";
import { useCurrentQuestions, useCurrentSurvey } from "@pulse/hooks/surveyHooks";
import { Link } from "@tanstack/react-router";
import { PageHeaderBack } from "frontend-components";
import { useTranslation } from "react-i18next";

export function PreviewSurveyContent() {
    const { t } = useTranslation();
    const { data: survey } = useCurrentSurvey();
    const { data: questions } = useCurrentQuestions();

    return (
        <div className="flex flex-col gap-4">
            <PageHeaderBack>
                <Link
                    to="."
                    search={{ preview: undefined }}
                    className="group text-text-secondary inline-flex items-center gap-2 self-start text-sm hover:underline"
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        className="text-compendia-greige group-hover:text-compendia-foreground size-4 transition-all duration-300 ease-out group-hover:-translate-x-1"
                    />
                    {t("survey.backToEdit")}
                </Link>
            </PageHeaderBack>
            <div className="border-compendia-border border-l-alert-info bg-compendia-card flex items-center gap-3 rounded-[3px] border border-l-[3px] px-4 py-3">
                <FontAwesomeIcon icon={faCircleInfo} className="text-alert-info size-4 shrink-0" />
                <p className="text-body-sm text-text-secondary">{t("survey.previewNotice")}</p>
            </div>
            <div className="flex justify-center">
                <SurveyLayout survey={survey} questions={questions} isLoading={false} isPreview>
                    <SurveySteps />
                </SurveyLayout>
            </div>
        </div>
    );
}
